import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CuttingService, IBasket } from '@shared/services/cutting.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-create-update-basket-dialog',
	templateUrl: './create-update-basket.html',
	styleUrls: ['./create-update-basket.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateUpdateBasketDialogComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();
	form: FormGroup;
	basket: IBasket;
	loading = false;
	httpError = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public editBasket: IBasket,
		public dialogRef: MatDialogRef<CreateUpdateBasketDialogComponent>,
		private cuttingService: CuttingService,
		private fb: FormBuilder,
	) {
		this.basket = {
			self: null,
			name: null,
			description: null,
			capacity: null,
			updatedDate: null,
			updatedBy: null,
		};

		if (editBasket) {
			this.basket = { ...editBasket };
		}
	}

	ngOnInit(): void {
		this.initializeForm();
	}

	private initializeForm(): void {
		this.form = this.fb.group({
			name: [this.basket.name, [Validators.required, Validators.maxLength(50), Validators.pattern(ValidatorPatterns.AllowedCuttingCharacters)]],
			description: [this.basket.description, [Validators.maxLength(100), Validators.pattern(ValidatorPatterns.DanishCharacters)]],
			capacity: [this.basket.capacity, [Validators.required, Validators.min(0), Validators.max(2147483647)]],
		});

		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.basket) {
					this.basket[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	async onSave(): Promise<void> {
		this.httpError = '';
		if (this.form.invalid || this.loading) return;
		this.loading = true;

		const saveObservable = this.basket.self ? this.cuttingService.updateBasket(this.basket) : this.cuttingService.createBasket(this.basket);

		saveObservable.subscribe({
			next: () => {
				this.saved.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
